import {
  connectWebSocket,
  disconnectWebSocket,
  sendWebSocketMessage,
} from "../slice";
import { wsService } from "./websocketService";

export const websocketMiddleware = (store) => (next) => (action) => {
  if (connectWebSocket.match(action)) wsService.connect(store);

  if (disconnectWebSocket.match(action)) wsService.disconnect();

  if (sendWebSocketMessage.match(action)) wsService.send(action.payload);

  return next(action);
};
